<match-wrapper
    label="{{ label }}"
    objectType="{{ objectType }}"
    fieldName="{{ fieldName }}"
    (onRemoveMatch)="removeMatch()"
    [showRemoveIcon]="!disabled"
>
    <div
        class="http-method-match-with-objects"
        [invalidateForm]="!config.methods?.length"
    >
        <enum-radio-buttons
            [noMarginTop]="true"
            enum="MatchOperation"
            name="method-match-with-objects_match-operation-{{ fieldName }}-{{ index }}"
            [(ngModel)]="config.match_criteria"
            [disabled]="disabled"
        ></enum-radio-buttons>
        <div class="http-method-match-with-objects__dropdown-wrapper">
            <label
                aviLabelWithTooltip
                objectType="{{ methodMatchObjectType }}"
                fieldName="methods"
                for="methods"
                required
            >
                {{ l10nKeys.methodLabel | vtranslate }}
            </label>
            <avi-enum-dropdown
                enum="HTTPMethod"
                name="method-match-with-objects_methods-{{ fieldName }}-{{ index }}"
                [(ngModel)]="config.methods"
                [multiple]="true"
                placeholder="{{ l10nKeys.methodPlaceholder | vtranslate }}"
                [disabled]="disabled"
                required
            ></avi-enum-dropdown>
        </div>
    </div>
</match-wrapper>
